import React, { PureComponent } from 'react';
import { Field, reduxForm } from 'redux-form';
import LogoUploadContainer from '../../../forms/Fields/LogoUpload/LogoUploadContainer';
import LoaderButton from '../../LoaderButton/LoaderButton';
import renderInput from '../../Fields/Input/Input';
import renderTextareaInput from '../../Fields/Textarea/Textarea';
import { compose } from 'redux';
import withScopedTranslations from '../../../withScopedTranslations/withScopedTranslations';
import PropTypes from 'prop-types';

class MainPageForm extends PureComponent {
  // eslint-disable-next-line class-methods-use-this
  formatSubdomain(value) {
    return value.replace(/[^a-z-]/g, '').replace(/-{2,}/g, '-');
  }

  render() {
    const { t, handleSubmit, pristine, submitting, } = this.props;
    const acceptedAvatarTypes = ['image/jpg', 'image/jpeg', 'image/png', 'image/bmp', 'image/gif'];
    const maxAvatarSize = 8388608;
    // 8Mb
    const isSubmitDisabled = pristine;

    return (
      <div className="row">
        <form className="settings-form" onSubmit={handleSubmit}>
          <div className="col-md-11 main-page-form__area">
            <div className="col-md-12">
              <h2 className="main-page-form__subtitle">{t('general_info_title')}</h2>
            </div>
            <div className="row">
              <div className="col-md-6">
                <label className="input-label">{t('logo')}</label>
                <Field
                  name="logo"
                  component={LogoUploadContainer}
                  acceptedTypes={acceptedAvatarTypes}
                  maxSize={maxAvatarSize}
                />
                <Field name="subdomain" hideMessages label={t('subdomain')} format={(value) => this.formatSubdomain(value)} component={renderInput} type="text" helpText={t('subdomain_help_text')} />
              </div>
              <div className="col-md-6">
                <Field name="header_title" hideMessages label={t('header_title')} component={renderInput} type="text" />
                <Field name="header_description" hideMessages label={t('header_description')} component={renderTextareaInput} type="text" />
                <Field name="header_slogan" hideMessages label={t('header_slogan')} component={renderTextareaInput} type="text" />
              </div>
              <div className="col-md-12 submit-area">
                <LoaderButton
                  isLoading={submitting}
                  disabled={isSubmitDisabled}
                  label={t('save')}
                />
              </div>
            </div>
          </div>
        </form>
        <style jsx="true">{`
          .main-page-form__area {
            padding-left: 15px;
            padding-top: 30px;
            border-left: 1px solid #e5e3e8;
            padding-bottom: 30px;
          }
          .main-page-form__subtitle {
            margin-bottom: 25px;
            font-weight: 400;
            font-size: 20px;
            margin-left: 15px;
          }
          .submit-area {
            margin-left: 15px;
          }
        `}</style>
      </div>
    );
  }
}
MainPageForm.propTypes = {
  t: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
}

export default compose(
  reduxForm({ form: 'mainPageForm', enableReinitialize: true, }),
  withScopedTranslations('content')
)(MainPageForm);
